import React, { useEffect } from 'react';
import {
  Control,
  UseFormRegister,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form';
import { Col, Row } from 'reactstrap';
import { FormFieldHeader } from '../../../../components/FormFieldHeader';
import { CheckboxPillGroupFormHook } from '../../../../components/CheckboxPillGroupFormHook';
import { CandidateDto } from '../../../../services/applicant_tracking/CandidateService/CandidateDto';
import classNames from 'classnames';

interface PropTypes {
  salaryInputColSize?: number;
  inputGroupClassNames?: string;
  containerClassNames?: string;
  formHeaderClassNames?: string;
  formControl: Control<CandidateDto>;
  disabled?: boolean;
  shouldRender: boolean;
  required: boolean;
  watch: UseFormWatch<CandidateDto>;
  formResetField: (controllerName: string) => void;
  formRegister: UseFormRegister<CandidateDto>;
  setValue?: UseFormSetValue<any>;
  width?: number;
  label?: string;
}

interface SalaryCurrencyPropTypes extends PropTypes {
  required: boolean;
}

function SalaryAndCurrency(props: SalaryCurrencyPropTypes) {
  const disabled = props.disabled ?? false;

  useEffect(() => {
    if (!props.watch('salaryCurrency') && !!props.watch('salaryExpectation')) {
      props.setValue('salaryCurrency', 'gbp');
    }
  }, [props.watch('salaryExpectation')]);

  return (
    <Row className={classNames(props.inputGroupClassNames)}>
      <Col xs={props.salaryInputColSize || 6}>
        <input
          className={classNames('form-control', 'fs-5')}
          type={'number'}
          placeholder='Insert salary'
          {...props.formRegister('salaryExpectation', {
            required: props.required,
          })}
          disabled={disabled}
        />
      </Col>
      <Col xs='auto'>
        <CheckboxPillGroupFormHook<CandidateDto>
          formHookContext={{
            controllerName: 'salaryCurrency',
            formControl: props.formControl,
            required: props.required,
          }}
          childrenClassNames={'px-3 py-1 ms-2'}
          resetField={props.formResetField}
          childrenProps={[
            { id: 'gbp', label: 'GBP', value: 'gbp' },
            { id: 'eur', label: 'EUR', value: 'eur' },
            { id: 'usd', label: 'USD', value: 'usd' },
            { id: 'jpy', label: 'JPY', value: 'jpy' },
          ]}
          disabled={disabled}
        />
      </Col>
    </Row>
  );
}

export function ApplicationSalaryInput(props: PropTypes) {
  if (!props.shouldRender) return null;

  return (
    <Row className={classNames(props.containerClassNames)}>
      <Col xs={props.width}>
        <FormFieldHeader
          fieldName={props.label ?? 'Expected Annual Salary'}
          isRequired={props.required}
          classNames={classNames(props.formHeaderClassNames)}
        />
        <SalaryAndCurrency {...props} />
      </Col>
    </Row>
  );
}
